import { BrickContext, ActionBrick, registerBrick, File as OFile, ErrorFlow } from 'olympe';
import {fromBase64} from "@olympeio/core";

export default class AddToFormData extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} name
     * @param {*} value
     * @param {*} formData
     * @param {function()} forwardEvent
     * @param {function(*)} setFormData
     */
    async update($, [name, value, formData], [forwardEvent, setFormData]) {
        let data = formData;
        if (!data) {
            data = new FormData();
        }

        if (value instanceof OFile) {
            try {
                const content = await value.getContentUrl();
                data.append(
                    name,
                    new Blob([fromBase64(content.substring(content.indexOf(';base64,')+8))], { type: value.get(File.mimeTypeProp) }),
                    value.get(File.fileNameProp)
                );
                setFormData(data);
                forwardEvent();
            } catch (e) {
                $.throw(ErrorFlow.create(`An error occurred while getting the file content ${error.message}`, 500))
            }
        } else {
            data.append(name, value);
            setFormData(data);
            forwardEvent();
        }
    }
}

registerBrick('0194b18eb20544570efd', AddToFormData);
